import { createAction, props } from '@ngrx/store';

export interface UserSettings {
  superEditMode: boolean;
  devMode: boolean;
  supportMode: boolean;
  showHiddenFields: boolean;
}

export const setSuperEditMode = createAction(
  'setSuperEdiMode',
  props<{ superEditMode: boolean }>()
);
export const setDevMode = createAction('setDevMode', props<{ devMode: boolean }>());
export const setSupportMode = createAction('setSupportMode', props<{ supportMode: boolean }>());
export const setHiddenFieldsMode = createAction(
  'showHiddenFields',
  props<{ showHiddenFields: boolean }>()
);
export const initUserSettings = createAction('initUserSettings');
